import { reactive } from 'vue'
import api from "../../api/v2/api"
import { ApiError } from "../../api/v2/api/base/response"
import Question, { ExamResultQuestion, ExamTestQuestion, GroupExamResultQuestion, GroupExamTestQuestion, GroupQuestion } from "../../api/v2/models/question"
import { ExamQScoreHistory } from "../../api/v2/models/q_score_history"
import Exam from "../models/exam"
import { SnackBar } from "../models/other_models"
import UserExam from "../models/user_exam"
import { examState } from "./exam"
import { snackBarState } from "./snackbar"

class ExamResultState {
    isLoading: boolean = false
    
    // リストのためのデータ
    examResultQuestions: ExamResultQuestion[] = []
    
    // 質問詳細のためのデータ
    groupQuestions: GroupQuestion[] = []

    // 質問履歴のためのデータ
    examQScoreHistory: ExamQScoreHistory | null = null
    currentGroupQuestion: GroupQuestion | null = null
    examResult: Exam | null = null
    private userExamId: number = 0
    redirectNotFoundPage: boolean = false

    get examTestIgnoreDescription(){
      return this.examResultQuestions.filter(examResultQuestion => !examResultQuestion.isDescriptionQuestion)
    }

    get examResultQuestionsAnswered(){
      return this.examResultQuestions.filter((item) => item.isAnswered)
    }

    get groupExamResultQuestions() : GroupExamResultQuestion[] {
        let result : GroupExamResultQuestion[] = []
        this.examResultQuestions.forEach(element => {
            let find = result.find(item => item.groupId == element.group)
            if (!find) {
                find = new GroupExamResultQuestion(element.group, [])
                result.push(find)
            }

            find.questions.push(element)
        });
        return result
    }

    setUserExamId(userExamId: number){
        if (this.userExamId != userExamId) {
            this.groupQuestions = []
        }

        this.userExamId = userExamId
    }

    getExamGroupQuestion(questionId: number) {
        return this.groupQuestions.find(item => !!item.questions.find(question => question.id == questionId))
    }

    async requestExamQScoreHistories(examId: number){
      if(!this.examResult || this.examResult.id != examId){
        this.examQScoreHistory = await api.exam.qScoreHistories(examId)
      }
    }

    async requestExamResult(examId: number){
        if(!this.examResult || this.examResult.id != examId){
            this.examResult = null
            try {
                this.isLoading = true
                this.examResult = await api.exam.showForResult(examId, {})
            } catch (error) {
                if (error instanceof ApiError) {
                    snackBarState.snackbar = new SnackBar(true, error.messages, error.apiStatus)
                    this.redirectNotFoundPage = true
                } else {
                    // Noop
                }
            } finally {
                this.isLoading = false
            }
        }
    }

    setRedirectNotFoundPage({ status }) {
        this.redirectNotFoundPage = status
    }

    async getExamResultQuestions() {
        try {
            this.examResultQuestions = await api.examQuestionApi.getIndexResult(this.userExamId)
            this.examResult.questions = []
            this.groupQuestions = []
            this.groupExamResultQuestions.forEach(async groupExamResultQuestion => {
                let questions = groupExamResultQuestion.questions.map(element => new Question(element))
                let groupQuestion = new GroupQuestion(questions[0].group, questions)
                this.groupQuestions.push(groupQuestion)
                // const groupQuestion = await this.requestExamGroupQuestion(groupExamResultQuestion.questions[0].id, true)
                this.examResult.questions.push(...questions)
                // this.examResult.questions.push(...groupQuestion.questions)
            })
        } catch (error) {
            if (error instanceof ApiError) {
                snackBarState.snackbar = new SnackBar(true, error.messages, error.apiStatus)
            } else {
                // Noop
            }
        }
    }

    async requestExamGroupQuestion(questionId: number, inBackground = false) {
        let groupQuestion = []
        if (this.userExamId && questionId) {
            try {
              if (!inBackground) {
                this.isLoading = true
              }
              const questions = await api.examQuestionApi.showResult(this.userExamId, questionId)
              if (questions.length) {
                  let groupQuestion = new GroupQuestion(questions[0].group, questions)
                //   this.groupQuestions.push(groupQuestion)
                  this.currentGroupQuestion = groupQuestion
              }
            } catch (error) {
              if (error instanceof ApiError) {
                  snackBarState.snackbar = new SnackBar(true, error.messages, error.apiStatus)
              } else {
                  // Noop
              }
            } finally {
              if (!inBackground) {
                this.isLoading = false
              }
            }
        }
        return groupQuestion
    }

    reset(){
      this.examResultQuestions = []
      this.groupQuestions = []
      this.examResult = null
      this.userExamId = 0
      this.currentGroupQuestion = null
      this.examQScoreHistory = null
    }
}


// Wrap in reactive() for Vue 3 reactivity
export const examResultState = reactive(new ExamResultState()) as ExamResultState
